module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inboxes-e2cba09a94575964719857a16fb42e41.svg";